import { Button, Card, CardBody, Tab, Tabs } from "@nextui-org/react";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import TableReportPreview from "../../../../components/fragments/admin/report/preview/TableReportPreview";
import TableReportTransportPreview from "../../../../components/fragments/admin/report/preview/TableReportTransportPreview";
import { useEffect, useMemo, useState } from "react";
import useAuth from "../../../../hooks/useAuth";
import useSWR from "swr";
import StatusPengajuanPelaporan from "../../../../enums/statusPengajuanPelaporan";
import { BASE_URL, getFetcher } from "../../../../services/api";
import useListCompany from "../../../../hooks/useListCompany";
import { month } from "../../../../services/enum";
import ReportStatusBadge from "../../../../components/elements/ReportStatusBadge";
import IsValidIcon from "../../../../components/elements/isValidIcon";
import ClientDataGrid from "../../../../components/elements/ClientDataGrid";
import { formattedDate } from "../../../../services/helpers";
import useCustomNavigate from "../../../../hooks/useCustomNavigate";
import { PencilIcon } from "@heroicons/react/24/outline";
import FilterReactSelect from "../../../../components/elements/FilterReactSelect";
import { useSelectedCompany } from "../../../../hooks/useSelectedCompany";

export default function IndexReviewPage() {
    const {roles} = useAuth();
    const { reviewPelaporanPengangkutan, reviewPelaporanPengelolaan } = useCustomNavigate();
    const [selectedCompany, setSelectedCompany] = useSelectedCompany()
    const [selectedPeriodRiwayat, setSelectedPeriodRiwayat] = useState(null);
    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const { data, isLoading, mutate } = useSWR(
        selectedPeriod
            ? `/api/period/search-pelaporan?periodId=${selectedPeriod.value}&status=${StatusPengajuanPelaporan.MENUNGGU_PERSETUJUAN}`
            : null, 
        getFetcher
    )
    /*
     * Tab Riwayat punya periodenya SENDIRI (selectedPeriodRiwayat), terpisah dari
     * periode tab Review - arsitektur yang sama dengan halaman sisi pengguna,
     * IndexUserPage.
     *
     * Sebelumnya kueri ini memakai selectedPeriod sementara select-nya menulis ke
     * selectedPeriodRiwayat yang tidak pernah dibaca siapa pun. Akibatnya
     * mengganti periode di tab Riwayat sama sekali tidak mengubah isi tabel.
     */
    const { data:dataRiwayat, isLoadingRiwayat, mutateRiwayat } = useSWR(
        selectedPeriodRiwayat && selectedCompany
            ? `/api/period/search-pelaporan?periodId=${selectedPeriodRiwayat.value}&companyId=${selectedCompany.value}&status=${StatusPengajuanPelaporan.DISETUJUI}`
            : selectedPeriodRiwayat ? `/api/period/search-pelaporan?periodId=${selectedPeriodRiwayat.value}&status=${StatusPengajuanPelaporan.DISETUJUI}` : null, 
        getFetcher
    )
    const { dataCompany, isLoadingCompany } = useListCompany()
    const { data: dataPeriod, isLoading: isLoadingPeriod } = useSWR(`/api/period/all`, getFetcher);
    useEffect(() => {
        if (dataPeriod) {
            const activePeriod = dataPeriod.find((item) => item?.isActive === true);
            if (activePeriod) {
                setSelectedPeriod({ label: activePeriod.name, value: activePeriod.id });
                // Ikut diisi supaya tab Riwayat tidak mulai kosong - sebelumnya ia
                // menumpang periode tab Review yang memang sudah punya nilai.
                setSelectedPeriodRiwayat({ label: activePeriod.name, value: activePeriod.id });
            }
        }
    }, [dataPeriod]);

    const columnReview = useMemo(() =>  [
        { field: 'kode', headerName: 'Kode Pelaporan' },
        { field: 'perusahaan', headerName: 'Perusahaan', valueGetter: (value, row) => row.company.name, },
        { field: 'periode', headerName: 'Periode', valueGetter: (value, row) => row.period.name,},
        { field: 'tipeLayanan', headerName: 'Tipe Pelaporan', valueGetter: (value, row) => row.tipeLayanan,},
        {
            field: 'buktiLapor',
            headerName: 'Bukti Laporan', // Pastikan selalu ada nilai fallback
            renderCell: (params) => {
                const buktiUrl = `${BASE_URL}/${params?.row?.buktiPelaporan?.url}`;
                return params?.row?.buktiPelaporan?.url ? (
                    <a 
                        href={buktiUrl} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="text-primary-500 underline"
                    >
                        Lihat Bukti Laporan
                    </a>
                ) : (
                    <span className="text-ink-500">Belum Upload</span> // Placeholder jika URL tidak ada
                );
            },
        },
        {
            field: 'status',
            headerName: 'Status',
            renderCell: (params) => (<ReportStatusBadge status={params.row.statusPelaporan} />),
            sortable: false,
            filterable: false,
        },
        {
            field: 'tanggalSubmit',
            headerName: 'Tanggal Submit Pelaporan',
            renderCell: (params) => (
                <div className="mt-1">
                    {formattedDate(params?.row?.tanggalSubmit)}
                </div>
            ),
            sortable: false,
            filterable: false,
        },
        {
            field: 'action',
            headerName: 'Aksi',
            renderCell: (params) => (
                <div className="flex items-center gap-1">
                    {/* <ModalDetailPurchase item={params.row} /> */}

                    { params?.row?.tipeLayanan === 'Kode Pelaporan Pengelolaan Bahan B3' ? 
                        <Button onPress={() => reviewPelaporanPengelolaan(params.row.company.id, params.row.period.id)} size='sm' color='warning' isIconOnly><PencilIcon className='size-4'/></Button>
                        : <Button onPress={() => reviewPelaporanPengangkutan(params.row.company.id, params.row.period.id)} size='sm' color='warning' isIconOnly><PencilIcon className='size-4'/></Button>
                    }
                    {/* {!params.row.isFinalized && } */}
                    
                </div>
            ),
            sortable: false,
            filterable: false
        },
    ], []);
    return(
        <RootAdmin>
            <Card radius="sm">
                <CardBody>
                    <Tabs
                        color="primary"
                        variant="underlined"
                        aria-label="tabs"
                        classNames={{
                            tabList: "gap-6 w-full relative rounded-none p-0 border-b border-divider",
                            cursor: "w-full",
                            tab: "max-w-fit px-1.5 h-12",
                            tabContent: "group-data-[selected=true]:font-semibold"
                        }}
                    >
                        <Tab key="1" title="Review Pelaporan">
                            <ClientDataGrid
                                columns={columnReview}
                                rows={data?.data}
                                isLoading={isLoading}
                                mutate={mutate}
                            />
                        </Tab>
                        <Tab key="2" title="Riwayat Pelaporan">
                        <div className="w-full flex justify-end items-center gap-2 mb-3">
                                <div className="w-1/4">
                                    <FilterReactSelect
                                        defaultValue={selectedCompany}
                                        placeholder="Cari Perusahaan"
                                        options={dataCompany?.data?.map(item => ({label: item.name, value: item.id}))}
                                        isLoading={isLoadingCompany}
                                        setValue={setSelectedCompany}
                                    />
                                </div>
                                <div className="w-1/4">
                                    <FilterReactSelect
                                        defaultValue={selectedPeriodRiwayat}
                                        placeholder="Cari Periode"
                                        options={dataPeriod?.map(item => ({label: item.name, value: item.id}))}
                                        isLoading={isLoadingPeriod}
                                        setValue={setSelectedPeriodRiwayat}
                                    />
                                </div>
                            </div>
                            <ClientDataGrid
                                columns={columnReview}
                                rows={dataRiwayat?.data}
                                isLoading={isLoadingRiwayat}
                                mutate={mutateRiwayat}
                            />
                        </Tab>
                    </Tabs>
                </CardBody>
            </Card>
        </RootAdmin>
    )
}
